export default __webpack_public_path__ + "static/media/15.820c6121.jpg";